import { render, staticRenderFns } from "./VHeaderLogo.vue?vue&type=template&id=68918fae&"
import script from "./VHeaderLogo.vue?vue&type=script&lang=ts&"
export * from "./VHeaderLogo.vue?vue&type=script&lang=ts&"
import style0 from "./VHeaderLogo.vue?vue&type=style&index=0&id=68918fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports